import cx from "classnames";
import React, { FC, useState } from "react";
import "./PublicLayoutContainer.scss";

type Props = {
  children: React.ReactNode;
  wide?: boolean;
};

const PublicLayoutContainer: FC<Props> = ({ children, wide }) => {
  const [isWide, setIsWide] = useState<boolean>(wide || false);

  return (
    <div
      className={cx("public-layout-container", {
        "public-layout-container--wide": isWide,
      })}
    >
      {children}
    </div>
  );
};

export default PublicLayoutContainer;
